/**
 * PNG DB Map
 *
 * Render the records stored in a png-db onto a Leaflet map.
 */


// Load the browser stylesheet if this is a browser build
{{BROWSER_CSS}}

// Load the REGL TileLayer
import '../lib/Leaflet.TileLayer.Regl';

// Gesture handling for mobile mode
import 'leaflet-gesture-handling';

// Load main class
import PngDBMap from './png-db-map';


/*
 * The creation of the PngDBMap is an asyncronous process, and we are not able to
 * create async constructors, so we wrap the creation in a promise that resolves
 * inside of the new PngDBMap object's constructor.
 *
 * @param {String|DOMElement} mount
 * @param Object config
 * @return Promise->PngDBMap
 */
export default function createPngDBMapAsync(mount, config) {
    return new Promise((resolve, reject) => {
        new PngDBMap(mount, config, pdbm => {
            {{SET_VERSION}}

            resolve(pdbm);
        });
    });
};
